<template>
  <div class="authorCenter">
    <authorHeader></authorHeader>
    <div class="breadbox">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <div class="clearfix bread">
          <img src="~img/direction.png" alt="" />
          <el-breadcrumb-item
            v-for="item in breadlist"
            :key="item.path"
            :to="{ path: item.path }"
            >{{ item.name }}</el-breadcrumb-item
          >
        </div>
      </el-breadcrumb>
    </div>
    <div class="contianer clearfix">
      <sidebar
        :navlist="navlist"
        :totalPage="totalPage"
        :isAuthor="true"
        @
      ></sidebar>
      <div class="con-right fr">
        <!-- 我写的书 -->
        <!-- {{$router}} -->
        <div class="writewrap" v-if="this.$route.path === '/author'">
          <h3>
            我写的书
            <a href="javaScript:" @click="goBookSet(0, false)" class="writebook"
              >创建作品</a
            >
          </h3>
          <writeList
            :booklist="booklist"
            :isSign="false"
            :isDel="true"
            @openbook="openbook"
            @getbookid="getbookid"
          ></writeList>
          <el-pagination
            background
            :page-size="10"
            layout="prev, pager, next"
            :current-page="coCurrent"
            :total="totalPage"
            class="paginnation-book"
            @current-change="currentChoose"
          >
          </el-pagination>
          <surePop :ApplyInfo="deleteInfo" @passbind="deletebook"></surePop>
        </div>
        <template v-else>
          <router-view></router-view>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { AuthorBookList, delectbook, finishbook } from 'apiurl/author';
export default {
  data() {
    return {
      navlist: [
        { url: "/author", name: "全部作品" },
         { url: "/author/income", name: "作品收入" },
        // { url: "/author/account", name: "账户中心" },
        { url: "/author/info", name: "作者资料" },
         { url: "/author/message", name: "消息中心" },
      ],
      booklist: [],
      breadlist: [], // 面包屑租
      uploadurl: "",
      totalPage: 8,
      coCurrent: 1,
      deleteInfo: {
        isShow: false,
        title: "删除作品",
        content: "是否要删除此作品？",
        hint: "* 一旦删除无法撤销",
        sure: "确定",
        cancle: "取消"
      },
      deleteId: null
    };
  },
  created() {
    this.getBreadcrumb();
    this.getwriteList(1);
  },
  watch: {
    $route() {
      /* 面包屑 */
      this.getBreadcrumb();
    }
  },
  methods: {
    getBreadcrumb() {
      let matched = this.$route.matched.filter(item => item.name);
      this.breadlist = matched;
      //   console.log(this.breadlist);
    },
    // 获取作者写书列表
    async getwriteList(pageNum) {
      let res = await AuthorBookList({ pageSize: 10, pageNo: pageNum });
      if (res.success) {
        this.booklist = res.data.items;
        this.totalPage = Number(res.data.totalCount);
      }
    },
    goBookSet(bookid, allowPrice) {
      this.$store.dispatch("setAInfo", {
        bookid: bookid,
        allowPrice: allowPrice,
        name: ""
      });
      this.$router.push("/authorManage/bookSetting/" + bookid);
    },
    currentChoose(value) {
      this.getwriteList(value);
      this.coCurrent = value;
    },
    openbook() {
      this.getwriteList(1);
    },
    getbookid(id) {
      this.deleteInfo.isShow = true;
      this.deleteId = id;
    },
    deletebook(boo) {
      if (boo) {
        delectbook(this.deleteId)
          .then(res => {
            if (res.success) {
              this.$message({
                message: "作品已删除！",
                type: "success"
              });
              this.getwriteList(1);
            }
          })
          .catch(() => {});
      }
    }
  }
};
</script>
<style lang="stylus" scoped>
.el-breadcrumb
    width 1180px
.contianer
    width 1180px
    margin 0px auto 0
    overflow hidden
    .con-right
        width 990px
        background #fff
        border 1px solid rgba(239, 239, 239, 1)
        min-height 736px
        position relative
        .writewrap
            .writebook
                display inline-block
                width 64px
                height 28px
                background #48A2DF
                font-size 12px
                line-height 28px
                text-align center
                font-weight 500
                color rgba(255, 255, 255, 1)
                margin-top 10px
                float right
        .paginnation-book
            position absolute
            right 20px
            bottom 20px
</style>
